import { BANKS } from '../data/bancos';

type Bank = { code: string; name: string };

let cachedBanks: Bank[] | null = null;

// For now the bank list lives only in the frontend.
const list = async (_useRemote = false): Promise<Bank[]> => {
  if (!cachedBanks) {
    cachedBanks = BANKS;
  }
  return cachedBanks;
};

const findByCode = (code: string): Bank | null => {
  if (!code) return null;
  const normalized = String(code).trim().padStart(3, '0');
  const pool = cachedBanks || BANKS;
  return pool.find(b => String(b.code) === normalized || String(b.code) === String(code)) || null;
};

export default { list, findByCode };
